import { render } from "./TestMetaDataHeader.vue?vue&type=template&id=80259e80"
import script from "./TestMetaDataHeader.vue?vue&type=script&lang=js"
export * from "./TestMetaDataHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__